// extracted by mini-css-extract-plugin
export default {"logoUploader":"clienteditpage_logoUploader__8KnpQ","image":"clienteditpage_image__eOA5K","form":"clienteditpage_form__xNiK2","buttons":"clienteditpage_buttons__S++HK"};